import { useFormikContext } from "formik";
import { useEffect } from "react";

export const InstantSubmit = () => {
  const { submitForm } = useFormikContext();

  useEffect(() => {
    submitForm();
  }, [submitForm]);

  return null;
};
